



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { memberLog } from '@/api/project';
import Event from '@/utils/event';
import moment from 'moment';

const typeMap = {
  1: '项目创建',
  2: '调整项目信息/成员组'
};

@Component({
  components: {}
})
class MemberHistory extends Vue {
  @Prop()
  companyId;

  logList: any[] = [];
  dotType = {
    1: 'blue',
    2: 'green'
  };
  legendList = [
    {
      text: '创建项目，认领项目',
      color: 'blue'
    },
    {
      text: '项目信息/成员组调整',
      color: 'green'
    }
  ];

  async created() {
    this.initLog();
  }

  async initLog() {
    let { companyId } = this;
    let res = await memberLog({ id: companyId });
    let list = res.data;
    list = list.map(log => {
      let { createName, createAt, content, type } = log;
      return {
        typeText: typeMap[type],
        createName,
        createAt: moment(createAt).format('YYYY-MM-DD hh:mm'),
        type,
        content
      };
    });
    this.logList = list;
  }

  goBack() {
    Event.$emit('toInfoDetail', 0);
  }
}

export default MemberHistory;
